
export enum DiscountActionTargetTypeEnum {
  ApplicableProducts,
  OtherProducts,
  Fees
}

export class DiscountActionTypeTarget {
    private shortName: string;
    private longName: string; 
    private description: string; 
    private enumValue: DiscountActionTargetTypeEnum

    constructor(enumValue: DiscountActionTargetTypeEnum, shortName: string, longName: string, description: string) {
      this.enumValue = enumValue;
      this.shortName = shortName;
      this.longName = longName;
      this.description = description;
    }

    toEnumValue() {
      return this.enumValue;
    }

    get ShortName() {
      return this.shortName; 
    }
  
    get LongName() {
      return this.longName; 
    }
  
    get Description() {
      return this.description;
    }
  
    private static readonly applicableProducts = new DiscountActionTypeTarget(
      DiscountActionTargetTypeEnum.ApplicableProducts,
      'Applicable products', 
      'Discount applicable products', 
      'Discount the applicable products by a percentage or amount. e.g. 15% off when booking 12 weeks or more.'); 

    private static readonly otherProducts = new DiscountActionTypeTarget(
      DiscountActionTargetTypeEnum.OtherProducts,
      'Other products', 
      'Discount other products', 
      'Create a discount that links to other products. e.g. Get 25% off residence accommodation when booking a course for 4 or more weeks');
    
    private static readonly fees = new DiscountActionTypeTarget(
      DiscountActionTargetTypeEnum.Fees,
      'Fees', 
      'Modify fees',
      'Reduce or waive fees. e.g. 25% off registration fee.');
        
    public static get ApplicableProducts() : DiscountActionTypeTarget { return DiscountActionTypeTarget.applicableProducts };
    public static get OtherProducts() : DiscountActionTypeTarget { return DiscountActionTypeTarget.otherProducts };
    public static get Fees() : DiscountActionTypeTarget { return DiscountActionTypeTarget.fees };
     
    static get AllValues() : DiscountActionTypeTarget[] {
      return [
        DiscountActionTypeTarget.ApplicableProducts, 
        DiscountActionTypeTarget.OtherProducts, 
        DiscountActionTypeTarget.Fees
      ];
    }

    static FromEnum(enumValue: DiscountActionTargetTypeEnum) {
      switch (enumValue) {
        case DiscountActionTargetTypeEnum.ApplicableProducts:
          return DiscountActionTypeTarget.ApplicableProducts;
        case DiscountActionTargetTypeEnum.OtherProducts:
          return DiscountActionTypeTarget.OtherProducts;
        case DiscountActionTargetTypeEnum.Fees:
          return DiscountActionTypeTarget.Fees;
        default: 
          throw new Error('Unknown discount action target enum: ' + enumValue)
      }
    }
  }

  export enum DiscountValueType {
    Percent,
    AmountPerUnit,
    OverrideUnitPrice
  }

